import { FC } from 'react';
import './HeightInputSuffixComponent.scss';

export interface HeightInputSuffixComponentProps {
  text: string;
}
export const HeightInputSuffixComponent: FC<HeightInputSuffixComponentProps> = ({ text }) => (
  <span className="inputSuffix">{text}</span>
);
